export default class Gallery {
    constructor() {
        this.selector = '.gallery';
        this.init();
    }

    init() {
        var self = this,
            $gallery = $( self.selector ),
            $galleryImages = $gallery.find( self.selector + '__images' );

        self.lightbox();

        $galleryImages.on( 'layoutComplete', function( e ) {
            var $this = $( this );
            $this.addClass( 'gallery__images--masonry' );
        } );

        $galleryImages.masonry( {
            itemSelector: self.selector + '__image',
            columnWidth: self.selector + '__sizer',
            percentPosition: true
        } );
    }

    lightbox() {
        $( 'a[data-rel^=lightcase]' ).lightcase( {
            maxWidth: 2560,
            maxHeight: 1600,
            showSequenceInfo: false,
            overlayOpacity: 1,
            shrinkFactor: 0.9
        } );
    }
}